// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1s1RC","unreadBadge":"styles_unreadBadge__2_z0C","modalContent":"styles_modalContent__vGQif","modal":"styles_modal__2gt4_"};